import ApiService from '../../services/CommonApiService'
import _ from 'lodash'
import Vue from 'vue'

export const namespaced = true
export const state = {
  loggedInUser: null,
  permissions: [],
  loading: 0,
  no_token_rquest: [],
  no_loading_request: [
    '/Data/LatestPodChartDataPoint',
    '/data/LatestCaliPodChartDataPoint',
    '/Data/LatestRecords'
  ]
}

export const mutations = {
  SET_LOADING: (state, loading) => {
    state.loading = state.loading + loading
  },
  STOP_LOADING: state => {
    state.loading = 0
  },
  SET_USER_DATA(state, userData) {
    state.loggedInUser = userData
    localStorage.setItem('user', JSON.stringify(userData))
  },
  SET_PERMISSIONS(state, permissions) {
    _.assignIn(state, permissions)
    localStorage.setItem('permissions', JSON.stringify(permissions))
  },
  LOGOUT() {
    localStorage.removeItem('user')
    location.reload()
  }
}

export const getters = {
  auth: () => module =>
    _.includes(JSON.parse(localStorage.getItem('permissions')), module),
  user: () => module =>
    JSON.parse(localStorage.getItem('user')).username === module
}

export const actions = {
  login({ commit }, credentials) {
    return new Promise((resolve, reject) => {
      ApiService.loginUser(credentials)
        .then(response => {
          let userData = {
            id: response.data.userId,
            username: credentials.username,
            token: response.data.token
          }
          commit('SET_USER_DATA', userData)

          //set permissions
          let permissions = []
          if (response.data.roles && response.data.roles.length) {
            response.data.roles.forEach(role => {
              role.modules.forEach(module => {
                module.childModules.forEach(childModule => {
                  childModule.permissions.forEach(ele => {
                    if (ele.isActive) {
                      permissions.push(
                        module.name + '.' + childModule.name + '.' + ele.name
                      )
                    }
                  })
                })
              })
            })
          }
          permissions = [...new Set(permissions)]
          commit('SET_PERMISSIONS', permissions)
          resolve(response)
        })
        .catch(error => {
          if (error.response.status == 401) {
            reject(Error('Invalid Credentials'))
          }
          reject(Error('Unknown Error'))
        })
    })
  },
  logout({ commit }) {
    Vue.prototype.stopSignalR()
    commit('LOGOUT')
  }
}
